import styled from "styled-components";
import { Container } from "components/shared";

export const FooterMain = styled.footer`
    padding: 2rem 0;
`;

export const FooterContainer = styled(Container)`
    display:flex;
    justify-content:space-between;
    align-items:center;
`;

export const Logo = styled.a`
    img {
        width: 4rem;
        height: auto;
    }
`;

export const LinkList = styled.ul`
    display: flex;
    align-items:center;
    li {
        margin-left:1rem;

        a {
            color: white;

            &:hover {
                color: var(--main);
            }
        }

        svg {
            width: 2.5rem;
            height: 2.5rem;
            fill: currentColor;
        }
    }
`;

export const Note = styled.p`
    font-size: 0.8rem;
    text-align: center;
    line-height:1.5;
`;
